import { faqItems } from "@/mocks/digData";

const siteUrl = "https://djyyiliao.cn/";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${siteUrl}#organization`,
      name: "瓜田速报",
      url: siteUrl,
      description: "网爆吃瓜连续剧追踪站，跟进后续反转、最新进展、当事人发声与官方回应。",
      email: "kefu@guatian-suhao.example.com",
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}#website`,
      url: siteUrl,
      name: "瓜田速报",
      inLanguage: "zh-CN",
      publisher: { "@id": `${siteUrl}#organization` },
      potentialAction: {
        "@type": "SearchAction",
        target: `${siteUrl}?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "CollectionPage",
      "@id": `${siteUrl}#webpage`,
      url: siteUrl,
      name: "网爆吃瓜连续剧追踪·后续反转与最新进展",
      description:
        "瓜田速报聚合网爆吃瓜连续剧，跟进后续反转、最新进展、当事人发声与官方回应，新瓜出现第一时间同步。",
      isPartOf: { "@id": `${siteUrl}#website` },
      inLanguage: "zh-CN",
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${siteUrl}#breadcrumb`,
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: siteUrl },
        { "@type": "ListItem", position: 2, name: "网爆吃瓜连续剧追踪", item: `${siteUrl}#timeline` },
      ],
    },
    {
      "@type": "FAQPage",
      "@id": `${siteUrl}#faq`,
      mainEntity: faqItems.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function SeoJsonLd() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}